exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".triangle-right[data-v-0f0fdab0]{width:0;height:0;border-style:solid;border-width:0 0 9px 9px;border-color:transparent transparent #b9ab9a transparent;position:absolute;left:-6px;top:-2px;z-index:-1}.tips-box[data-v-0f0fdab0]{position:absolute;width:200px;height:30px;right:0;top:-8px;z-index:100}.btn[data-v-0f0fdab0]{border-radius:6px;background:#fff;line-height:17px;padding:0 5px;text-align:center}.h-bor[data-v-0f0fdab0]{border:1px solid rgba(0,0,0,.05)}", ""]);

// exports
